const app = {
	title: 'Otipass platform',
	subtitle: 'Configuration form for your platform',
	langFr: 'French',
	langEn: 'English',
	langSelectLabel: 'Language',
	logoAlt: 'Otipass logo',
	nav: {
		step: 'Step',
		previous: 'Previous',
		next: 'Next',
		recap: 'Summary',
		send: 'Send',
		save: 'Save',
	},
	jsonImport: {
		button: 'Load a JSON file',
		aria: 'Load a JSON file to prefill the form',
	},
	alerts: {
		readFile: 'Could not read the file.',
		jsonObject: 'The JSON file must contain an object (not an array or a primitive).',
		jsonInvalid: 'Invalid JSON file. Please check the format.',
		readError: 'Error while reading the file.',
		submitError: 'Error while submitting the form.',
	},
	breadcrumb: {
		1: 'Project',
		2: 'Issuer',
		3: 'Services',
		4: 'Tourist data',
		5: 'Visuals & support',
		6: 'Readers',
		7: 'Website',
		8: 'Social networks',
		9: 'Registrations & shop',
		10: 'Finance',
		11: 'Languages & misc.',
		12: 'Contacts',
		13: 'Plans',
		14: 'Summary',
	},
	common: {
		yes: 'Yes',
		no: 'No',
		none: 'none',
		other: 'Other',
		noneF: 'None',
		modify: 'Edit',
		example: 'E.g. {{text}}',
		dash: '—',
		europe: 'Europe',
		requiredFields: 'required',
	},
};

export default app;
